import { gql } from "@apollo/client";

const NOTIFICATION_ADDED = gql`
  subscription notificationAdded($where: NotificationWhereInput) {
    notificationAdded(where: $where) {
      id
      type
      importance
      title
      content
      meta
      createdDate
      isReadBy {
        id
      }
      recipients {
        id
      }
    }
  }
`;

const NOTIFICATION_UPDATED = gql`
  subscription notificationUpdated($where: NotificationWhereInput) {
    notificationUpdated(where: $where) {
      id
      type
      importance
      title
      content
      meta
      createdDate
      isReadBy {
        id
      }
    }
  }
`;

const NOTIFICATION_DELETED = gql`
  subscription notificationDeleted($where: NotificationWhereInput) {
    notificationDeleted(where: $where) {
      id
      type
      importance
      title
      content
      meta
      createdDate
      isReadBy {
        id
      }
    }
  }
`;

const notifications = {
  NOTIFICATION_ADDED,
  NOTIFICATION_UPDATED,
  NOTIFICATION_DELETED,
};

export default notifications;
